import { render, staticRenderFns } from "./WfConsumerUserOperationList.vue?vue&type=template&id=8baef4a6&scoped=true&"
import script from "./WfConsumerUserOperationList.vue?vue&type=script&lang=js&"
export * from "./WfConsumerUserOperationList.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerUserOperationList.vue?vue&type=style&index=0&id=8baef4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baef4a6",
  null
  
)

export default component.exports